import { __require as r } from "../node_modules/use-sync-external-store/shim/index.mjs";
var i = r();
export {
  i as s
};
